import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router";
//data
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
//component
import Header from "../../../components/molecules/Header";
import Gap from "../../../components/atoms/Gap";
import ListItemMap from "./listItem";
// material
import Skeleton from "@material-ui/lab/Skeleton";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
//style
import useStyles from "./style";
//utils
import currency from "./../../../utils/currency";

function KomisiSaya() {
  const classes = useStyles();
  const history = useHistory();
  const { profil } = useData();
  const [komisi, setKomisi] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const [loadingTransaksi, setLoadingTransaksi] = useState(false);
  const [transaksi, setTransaksi] = useState({
    total_komisi_webstore: 0,
    total_komisi_jaringan: 0,
    total_komisi_saya: 0,
  });

  const {
    total_komisi_webstore,
    total_komisi_jaringan,
    total_komisi_saya,
    total_komisi_tertahan,
  } = transaksi;

  const getTotalTransaksiSeller = useCallback(async () => {
    setLoadingTransaksi(true);
    const transaksi = firefunctions.httpsCallable("getTotalTransaksiSeller");
    const res = await transaksi({ user_id: profil.id });

    setTransaksi(res.data);
    setLoadingTransaksi(false);
  }, [profil.id]);
  useEffect(() => {
    getTotalTransaksiSeller();
  }, []);

  const getTotalKomisiSeller = useCallback(async () => {
    const transaksi = firefunctions.httpsCallable("getDetailKomisi");
    const res = await transaksi({ user_id: profil.id });
    setKomisi(res.data);
    setIsReady(true);
  });

  useEffect(() => {
    getTotalKomisiSeller();
  }, []);

  return (
    <>
      <Header
        type="with-title"
        title="Komisi Saya"
        onClick={() => history.goBack()}
      />
      <div
        className={classes.hero}
        style={{
          backgroundColor: "#F5F5F5",
        }}
      >
        <Gap height={20} />
        <div className={classes.wrapHeader}>
          <Typography className={classes.liquidSecond}>
            Total Komisi Saya
          </Typography>
          {loadingTransaksi ? (
            <div style={{ justifyContent: "center", display: "flex" }}>
              <Skeleton width="20%" />
            </div>
          ) : (
            <Typography className={classes.liquidTitle}>
              {currency(total_komisi_saya)}
            </Typography>
          )}
        </div>
        <div className={classes.wrapCard}>
          <Card>
            <CardContent>
              <Grid container justify="space-evenly">
                <Grid item className={classes.wrapGrid}>
                  <Typography className={classes.liquidPrimary}>
                    Komisi Webstore
                  </Typography>
                  {loadingTransaksi ? (
                    <Skeleton variant="text" />
                  ) : (
                    <Typography className={classes.liquidSecond}>
                      {currency(total_komisi_webstore)}
                    </Typography>
                  )}
                </Grid>
                <Grid item className={classes.wrapGrid}>
                  <Typography className={classes.liquidPrimary}>
                    Komisi Jaringan
                  </Typography>
                  {loadingTransaksi ? (
                    <Skeleton variant="text" />
                  ) : (
                    <Typography className={classes.liquidSecond}>
                      {currency(total_komisi_jaringan)}
                    </Typography>
                  )}
                </Grid>
                <Grid item className={classes.wrapGrid}>
                  <Typography
                    className={classes.liquidPrimary}
                    style={{ color: "#fa8e00" }}
                  >
                    Komisi Tertahan
                  </Typography>
                  {loadingTransaksi ? (
                    <Skeleton variant="text" />
                  ) : (
                    <Typography className={classes.liquidSecond}>
                      {currency(total_komisi_tertahan)}
                    </Typography>
                  )}
                </Grid>
              </Grid>
              <Gap height={10} />
              <Divider />
              <Gap height={10} />
              <div className={classes.wrapBtnList}>
                <CardActions>
                  <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    onClick={() => history.push("/")}
                  >
                    Bagikan Produk & Tingkatkan Jaringan
                  </Button>
                </CardActions>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      <div className={classes.wrapList}>
        <List
          subheader={
            <ListSubheader disableSticky={true}>Riwayat Komisi</ListSubheader>
          }
        >
          {!isReady ? (
            <Skeleton variant="text" />
          ) : komisi.length > 0 ? (
            komisi.map((item, index) => {
              return <ListItemMap key={index} data={item} />;
            })
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                marginTop: "2.5%",
              }}
            >
              <Typography className={classes.liquidPrimary}>
                Tidak Ada Data
              </Typography>
            </div>
          )}
        </List>
      </div>
    </>
  );
}

export default KomisiSaya;
